export const PhaseItemsActions = {
  FETCH_ALL_PHASE_ITEMS_REQUEST: 'FETCH_ALL_PHASE_ITEMS_REQUEST',
  FETCH_ALL_PHASE_ITEMS_SUCCESS: 'FETCH_ALL_PHASE_ITEMS_SUCCESS',
  FETCH_ALL_PHASE_ITEMS_ERROR: 'FETCH_ALL_PHASE_ITEMS_ERROR',
}
